export const EOrderCurrentStatus = {
  Pending: 0,

  Preparing: 1,

  Finished: 2,

  Closed: 3,
} as const

export type EOrderCurrentStatus = (typeof EOrderCurrentStatus)[keyof typeof EOrderCurrentStatus]
